import { HStack, Skeleton, Stack } from "@chakra-ui/react";
import React from "react";

const TemplateListsSkeleton: React.FC = () => {
	return (
		<Stack>
			<Skeleton w="140px" h="16px" mt="16px" mb="8px" />
			{Array.from({ length: 4 }).map((_, i) => (
				<HStack
					key={i}
					justify="space-between"
					p="12px"
					border="1px solid"
					borderColor="#e0e0e0"
					borderRadius="base"
				>
					<HStack flex="1">
						<Skeleton w="180px" h="16px" />
						<Skeleton w="80px" h="16px" />
						<Skeleton w="50px" h="20px" borderRadius="2px" />
					</HStack>
					<HStack>
						<Skeleton w="36px" h="20px" borderRadius="20px" />
						<Skeleton w="20px" h="20px" />
					</HStack>
				</HStack>
			))}
		</Stack>
	);
};

export default TemplateListsSkeleton;
